module.exports = __webpack_public_path__ + "img/opening.32bbb202.jpg";